/**
 * axios封装
 * 请求拦截、响应拦截、错误统一处理
 */
import Vue from 'vue'
import axios from 'axios';
import router from '../router';
import store from '../store/index';
import _ from 'lodash'
import qs from 'qs'; // 根据需求是否导入qs模块
import {
  Message,
  Loading
} from 'element-ui'

axios.defaults.withCredentials = true
axios.defaults.baseURL = process.env.BASE_URL
let loadingInstance;
let needLoadingRequestCount = 0;
// 创建一个集合来存储最近显示的错误消息内容
const recentErrors = new Set();
function showLoading(mask) {
  if(mask==true){
    // let main = document.querySelector('#app')
    let main = document.body
    if (main) {
      if (needLoadingRequestCount === 0 && !loadingInstance) {
        loadingInstance = Loading.service({
          target: main,
          text: '正在努力加载中，请稍后 ... ...',
          background: 'rgba(0, 0, 0, 0.8)'
        });
      }
      needLoadingRequestCount++;
    }
  }
}

function closeLoading() {
  Vue.nextTick(() => {
    needLoadingRequestCount--;
    needLoadingRequestCount = Math.max(needLoadingRequestCount, 0);
    if (needLoadingRequestCount === 0) {
      if (loadingInstance) {
        hideLoading();
      }
    }
  });
}

var hideLoading = _.debounce(() => {
  loadingInstance.close()
  loadingInstance = null
}, 300);
/**
 * 提示函数
 * 禁止点击蒙层、显示一秒后关闭
 */
const tipError = msg => {
  if (!recentErrors.has(msg)) {
    recentErrors.add(msg);
    // 消息不存在，不显示
    var options = {
      message:msg,
      onClose:function (){
        recentErrors.delete(msg);
      }
    }
    Message.error(options);
  }

}
/**
 * 提示函数
 * 禁止点击蒙层、显示一秒后关闭
 */
const tipWarning = msg => {
  if (!recentErrors.has(msg)) {
    recentErrors.add(msg);
    // 消息不存在，不显示
    var options = {
      message:msg,
      onClose:function (){
        recentErrors.delete(msg);
      }
    }
    Message.warning(options);
  }
}

/**
 * 跳转登录页
 * 携带当前页面路由，以期在登录页面完成登录后返回当前页面
 */
const toLogin = (m) => {
  //转入登陆页面必须走重定向得方法，否则会出现域名混乱
  // router.replace({
  //   path: '/login',
  //   query: {
  //     redirect: router.currentRoute.fullPath
  //   }
  // });
  m = "?m=" + m || "";
  var targetUrl = Vue.prototype.$base.WEB_PATH_CA + "/login" + m;
  window.location.href = targetUrl;
}


/**
 * 请求失败后的错误统一处理
 * @param {Number} status 请求失败的状态码
 */
const errorHandle = (status, other) => {
  other = other || {};
  // 状态码判断
  switch (status) {
    // 401: 未登录状态，跳转登录页
    case 204:
      tipWarning(other.msg || other.message || "内容不存在！")
      break;
      // 401: 未登录状态，跳转登录页
    case 401:
      tipError(other.msg || other.message || "用户名或密码错误！")
      break;
    case 403:
      var showMsg = "";
      var _msg = other.msg || other.message || '登录超时！'
      if(_msg=="Forbidden"){
        showMsg = "您没有权限！";
      }else{
        showMsg = "登录超时！";
      }
      tipError(showMsg);
      setTimeout(() => {
        toLogin(showMsg);
      }, 1000);
      break;
    case 404:
      tipError(other.msg || other.message || '请求的资源不存在！');
      break;
    case 405:
      tipError('请求的资源不存在！');
      break;
    case 406:
      tipError(other.msg || other.message || '24小时内登录失败次数超过最大限制，已被禁止登录！');
      break;
    case 417:
      tipWarning(other.msg || other.message || '电子邮箱未认证，请先认证后再继续操作！');
      break;
    case 422:
      tipError(other.msg || other.message || '信息不正确');
      break;
    case 429:
      tipError(other.msg || other.message || '操作频繁，请稍后再试！');
      break;
    case 452:
      setTimeout(() => {
        toLogin(other.msg || other.message || '本次操作已超时过期，请重新登录！');
      }, 1500);
      break;
    case 453:
      tipError(other.msg || other.message || '请重新验证身份');
      break;
    case 454:
      tipError(other.msg || other.message || '当前时间段不可操作');
      break;
    case 455:
      setTimeout(() => {
        toLogin(other.msg || other.message || '电子证书已失效，请重新下载！');
      }, 1500);
      break;
    case 500:
      tipError('服务器内部错误！');
      break
    case 501:
      tipError('服务未实现！');
      break
    case 502:
      tipError('网关错误！');
      break
    case 503:
      tipError('服务不可用！');
      break
    case 504:
      tipError('网关超时！');
      break
    case 505:
      tipError('HTTP版本不受支持！');
      break
    default:
      tipError(other.msg || other.message || '未知的错误，请联系管理员！')
      console.log(other);
  }
}
// 创建axios实例 超时设定默认：60秒
var instance = axios.create({
  timeout: 5000 * 12 * 5
});
// 设置post请求头
instance.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
/**
 * 请求拦截器
 * 每次请求前，如果存在token则在请求头中携带token
 */
instance.interceptors.request.use(
  config => {
    var _mask = true
    if(config.mask==false){
      _mask = false
    }

    showLoading(_mask);
    // 登录流程控制中，根据本地是否存在token判断用户的登录情况
    // 但是即使token存在，也有可能token是过期的，所以在每次的请求头中携带token
    // 后台根据携带的token判断用户的登录情况，并返回给我们对应的状态码
    // 而后我们可以在响应拦截器中，根据状态码进行一些统一的操作。
    if (store.getters.getToken) {
      config.headers[Vue.prototype.$requestKey] = store.getters.getToken
    }
    //时间戳设定
    if (config.method == 'get') {
      config.params = {
        _t: Date.parse(new Date()) / 1000,
        ...config.params
      }
    } else if (config.method === 'post' && config.data instanceof FormData) {
        config.headers['Content-Type'] = 'multipart/form-data';
    } else {
      config.data = {
        ...config.data,
        _t: Date.parse(new Date()) / 1000
      }
      config.data = qs.stringify(config.data);
    }

    // token && ();
    return config;
  },
  error => {
    closeLoading();
    return Promise.error(error);
  })

// 响应拦截器
instance.interceptors.response.use(
  // 请求成功
  res => {
    closeLoading();
    return res.status === 200 ? Promise.resolve(res) : Promise.reject(res);
  },
  // 请求失败
  error => {
    closeLoading();
    const {
      response
    } = error;
    if (response) {
      // 请求已发出，但是不在2xx的范围
      errorHandle(response.status, response.data);
      return Promise.reject(response);
    } else {
      // 处理断网的情况
      // eg:请求超时或断网时，更新state的network状态
      // network状态在app.vue中控制着一个全局的断网提示组件的显示隐藏
      // 关于断网组件中的刷新重新获取数据，会在断网组件中说明
      if (!window.navigator.onLine) {
        tipError("网络错误，无法链接服务器！")
      } else {
        return Promise.reject(error);
      }
    }
  });




export default instance;



// WEBPACK FOOTER //
// ./src/utils/http.js